import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';
import { CreatePage } from '../create/create.page';


@Component({
  selector: 'app-select',
  templateUrl: './select.page.html',
  styleUrls: ['./select.page.scss'],
})
export class SelectPage implements OnInit {


  @Input() remove_surveys = [];
  @Input() in_surveys = [];

  @Input() source_header = 'Available Forms';
  @Input() target_header = 'Selected Forms';
  @Input() modal_title = 'Select Forms';

  @Input() selected_surveys: any = [];
  surveys: any = [];

  constructor(
    private modalController: ModalController,
    private apiService: ApiService,
    public globalService: GlobalService
  ) { }

  ngOnInit() {
    this.GetData();
  }



  async Close() {
    this.modalController.dismiss(null);
  }

  async GetData() {
    if (this.in_surveys.length == 0)
      await this.GetSurveys();
    else {
      this.surveys = this.in_surveys;
      if (this.remove_surveys && this.remove_surveys.length > 0) {
        for (let i = 0; i < this.remove_surveys.length; i++) {
          let index = this.globalService.GetArrayIndex(this.surveys, this.remove_surveys[i].guid);
          if (index >= 0) this.surveys.splice(index, 1);
        }
      }
    }
  }

  async GetSurveys() {
    let data: any = await this.apiService.get('surveys');
    console.log("Surveys",data);
    if (data.success) {
      this.surveys = data.data;
      if (this.remove_surveys && this.remove_surveys.length > 0) {
        for (let i = 0; i < this.remove_surveys.length; i++) {
          let index = this.globalService.GetArrayIndex(this.surveys, this.remove_surveys[i].guid);
          if (index >= 0) this.surveys.splice(index, 1);
        }
      }
    }
  }


  async Finish() {
    this.modalController.dismiss(this.selected_surveys);
  }

  async presentCreateSurveyModal() {
    const modal = await this.modalController.create({
      component: CreatePage,
      cssClass: 'large-modal secondary-modal',
      backdropDismiss: false,
      componentProps: {
        creating_template: true
      }
    });
    modal.onDidDismiss().then((data: any) => {
      if (data.data) {
        this.selected_surveys = [...this.selected_surveys, data.data];
      }
    });
    return await modal.present();
  }
}
